import styled, { css } from 'styled-components';

export const PositionedWrapper = styled.div`
  position: sticky;
  z-index: 20;
  top: 50%;
  width: 100%;
`;

export const SpacingWrapper = styled.div`
  ${({ theme }) => css`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    padding: ${theme.spacing.km5};
    max-width: 395px;
  `}
`;

export const RequestAccessContent = styled.div`
  ${({ theme }) => css`
    border-radius: ${theme.border.radius.large};
    background: ${theme.color.background.neutral.default};
    box-shadow: ${theme.elevation.ton8};
    width: 100%;
    text-align: center;
    padding: ${theme.spacing.km6};
  `}
`;
